import { render, staticRenderFns } from "./infoReparaciones.vue?vue&type=template&id=6c87a2c1&scoped=true&"
var script = {}
import style0 from "./infoReparaciones.vue?vue&type=style&index=0&id=6c87a2c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87a2c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
